import React from 'react'
import { connect } from 'react-redux'

class LectureListCount extends React.Component {
    getCount (type, lectures, channels) {
        if (type === 'lecture') {
            return this.props.lecturesCount
        } else {
            return channels && channels.length || 0
        }
    }
    render() {
        const { type, lectures, channels, isLecturesEmpty, isChannelsEmpty } = this.props
        if (lectures && type === 'lecture' && lectures.length === 0 && isLecturesEmpty) return null
        if (channels && type === 'channel' && channels.length === 0 && isChannelsEmpty) return null
        return (
            <div className="title">
                {this.props.typeText}（{this.getCount(this.props.type, this.props.lectures, this.props.channels)}）
            </div>
        )
    }
}

export default connect(state => ({
    lectures: state.liveroomSettingLecture.lectures,
    channels: state.liveroomSettingLecture.channels,
    lecturesCount: state.liveroomSettingLecture.lecturesCount,
    isLecturesEmpty: state.liveroomSettingLecture.isLecturesEmpty,
    isChannelsEmpty: state.liveroomSettingLecture.isChannelsEmpty,
}))(LectureListCount)



// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/LectureListCount.js